<template>
  <div class="vx-row">
    <vs-col vs-lg="8" vs-md="6" vs-sm="12">
      <div class="ph-item">
        <div class="ph-col-12">
          <div class="ph-row">
            <!-- Header  -->
            <div class="ph-col-8 big"></div>
            <div class="ph-col-10"></div>
            <!-- Header  -->

            <!-- Separator -->
            <div class="ph-col-12 empty"></div>
            <div class="ph-col-12 empty"></div>
            <!-- Separator -->

            <!-- Input  -->
            <div class="ph-col-4"></div>
            <div class="ph-col-8 empty"></div>
            <div class="ph-col-6 big"></div>
            <div class="ph-col-6 empty"></div>
            <!-- Input  -->

            <!-- style="border:1px solid red" -->

            <!-- Input Row  -->
            <div class="ph-col-4"></div>
            <div class="ph-col-3 empty"></div>
            <div class="ph-col-4"></div>

            <div class="ph-col-6 big"></div>
            <div class="ph-col-1 empty"></div>
            <div class="ph-col-5 big"></div>
            <!-- Input Row  -->

            <!-- Input Row  -->
            <div class="ph-col-4"></div>
            <div class="ph-col-1 empty"></div>
            <div class="ph-col-3"></div>
            <div class="ph-col-1 empty"></div>
            <div class="ph-col-3"></div>

            <div class="ph-col-4 big"></div>
            <div class="ph-col-1 empty"></div>
            <div class="ph-col-3 big"></div>
            <div class="ph-col-1 empty"></div>
            <div class="ph-col-3 big"></div>
            <!-- Input Row  -->

            <!-- Input Row  -->
            <div class="ph-col-4"></div>
            <div class="ph-col-3 empty"></div>
            <div class="ph-col-4"></div>

            <div class="ph-col-6 big"></div>
            <div class="ph-col-1 empty"></div>
            <div class="ph-col-5 big"></div>
            <!-- Input Row  -->

            <!-- Input Row  -->
            <div class="ph-col-4"></div>
            <div class="ph-col-1 empty"></div>
            <div class="ph-col-3"></div>
            <div class="ph-col-1 empty"></div>
            <div class="ph-col-3"></div>

            <div class="ph-col-4 big"></div>
            <div class="ph-col-1 empty"></div>
            <div class="ph-col-3 big"></div>
            <div class="ph-col-1 empty"></div>
            <div class="ph-col-3 big"></div>
            <!-- Input Row  -->
          </div>
        </div>
      </div>
    </vs-col>

    <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
      <div class="ph-item">
        <div class="ph-col-12">
          <div class="ph-row">
            <!-- Header  -->
            <div class="ph-col-12 big"></div>
            <!-- Header  -->

            <!-- Separator -->
            <div class="ph-col-12 empty"></div>
            <!-- Separator -->

            <!-- Input  -->
            <div class="ph-col-4"></div>
            <div class="ph-col-8 empty"></div>
            <div class="ph-col-6 big"></div>
            <!-- Input  -->
          </div>
        </div>
      </div>

      <div class="ph-item">
        <div class="ph-col-12">
          <div class="ph-row">
            <!-- Header  -->
            <div class="ph-col-12 big"></div>
            <!-- Header  -->

            <!-- Separator -->
            <div class="ph-col-12 empty"></div>
            <!-- Separator -->

            <!-- Input  -->
            <div class="ph-col-4"></div>
            <div class="ph-col-8 empty"></div>
            <div class="ph-col-6 big"></div>
            <!-- Input  -->

            <!-- Separator -->
            <div class="ph-col-12 empty"></div>
            <!-- Separator -->

            <!-- Input  -->
            <div class="ph-col-4"></div>
            <div class="ph-col-8 empty"></div>
            <div class="ph-col-6 big"></div>
            <!-- Input  -->
          </div>
        </div>
      </div>
    </vs-col>
  </div>
</template>

<script>
export default {
  name: "contrato-form-placeholder"
};
</script>